module.exports = __webpack_public_path__ + "img/stock5.6ad98885.png";